import { render, staticRenderFns } from "./subMenu.vue?vue&type=template&id=8b65e450"
import script from "./subMenu.vue?vue&type=script&lang=js"
export * from "./subMenu.vue?vue&type=script&lang=js"
import style0 from "./subMenu.vue?vue&type=style&index=0&id=8b65e450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports